export const API_STATE_UPDATE_CALL_STATUS = 'API_STATE_UPDATE_CALL_STATUS';
//# sourceMappingURL=types.js.map